export default __webpack_public_path__ + "static/media/pagoEfectivo.f27db612.png";